/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events */
import EVENTS from '@/utils/Constants/Events';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import utils
import { productImageByFormat } from '@/utils/Common/ProductImage';
import { goToPage } from '@/utils/Common/Redirects';
import CONST from '@/utils/Constants/General';
import LINK from '@/utils/Constants/Link';

// import components
import ButtonSocial from '@/components/atoms/ButtonSocial';
import ButtonTextIcon from '@/components/atoms/ButtonTextIcon';
import Chips from '@/components/molecules/Chips';
import Select from '@/components/molecules/Select';
import CartVatRow from '@/components/organisms/CartVatRow';
import PriceBox from '@/components/organisms/OrderProductBox/PriceBox';

const SubscriptionCartItem = ({ item, addAccessories }) => {
  const { isSubscription } = item;

  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [DescriptionHeight, setDescriptionHeight] = useState(0);

  const descriptionRef = useRef();

  const { t } = useTranslation();

  const hasCartIcon = item.rootGroup?.rootBundleTemplate?.images?.find(
    image => image.format === CONST.PRODUCT.IMAGE.FORMAT.CART_ICON,
  );

  const iconFormat = hasCartIcon
    ? CONST.PRODUCT.IMAGE.FORMAT.CART_ICON
    : CONST.PRODUCT.IMAGE.FORMAT.THUMBNAIL;

  const itemThumbnail = productImageByFormat(
    item.rootGroup?.rootBundleTemplate?.images,
    iconFormat,
  );

  const removeItem = () => {
    DLG.EVE.emit(EVENTS.CART.BUNDLE.DELETE, {
      entryGroupNumber: item.rootGroup.groupNumber,
      successMessage: t('cart:cart.entry.removed.success'),
    });
  };

  const editConfigurableProduct = () => {
    const configurationID = item?.configurableProductDataConfigurationId;
    const productCode = item?.productCode;

    goToPage(LINK.PDP_CONFIGURABLE(productCode, configurationID));
  };

  const productConfigurable =
    item?.configurableProductDataConfigurationId &&
    item?.configurableProductDataSnapshot;

  const thumbnailBASE64 = item?.configurableProductDataSnapshot;

  const thumbnailLargeUrl = productConfigurable
    ? thumbnailBASE64
    : itemThumbnail?.url;
  const thumbnailMediumUrl = productConfigurable
    ? thumbnailBASE64
    : itemThumbnail?.url;
  const thumbnailSmallUrl = productConfigurable
    ? thumbnailBASE64
    : itemThumbnail?.url;
  const thumbnailAltText = itemThumbnail?.altText;

  const descriptionRefHandler = () => {
    const { scrollHeight } = descriptionRef.current;

    if (isDescriptionOpen) {
      setDescriptionHeight(0);
    } else {
      setDescriptionHeight(scrollHeight);
    }

    setIsDescriptionOpen(prevState => !prevState);
  };

  const hasDiscount =
    item?.rootGroup?.rootBundleTemplate?.oneTimePriceData?.value <
    item.rootGroup?.rootBundleTemplate?.recurringPriceData?.value;

  const mainPriceData = item.rootGroup?.rootBundleTemplate?.oneTimePriceData;
  const oldPriceData = item.rootGroup?.rootBundleTemplate?.recurringPriceData;

  return (
    <div className='dln-cartItem x-bundle-cart-item'>
      <div className='dln-cartItem__content'>
        <div className='dln-cartItem__article'>
          <picture className='dln-image dln-cartItem__picture'>
            <source media='(min-width: 1200px)' srcSet={thumbnailLargeUrl} />
            <source
              media='(min-width: 600px) and (max-width: 1199px)'
              srcSet={thumbnailMediumUrl}
            />
            <img
              className='dln-image__image'
              src={thumbnailSmallUrl}
              alt={thumbnailAltText}
            />
          </picture>
          <div className='dln-cartItem__description'>
            <div className='dln-cartItem__titleWrapper'>
              <h3 className='dln-cartItem__title'>
                {item.rootGroup?.rootBundleTemplate?.rootBundleTemplateName ||
                  item.productName}
              </h3>
              <div className='dln-cartItem__topCta'>
                {productConfigurable ? (
                  <ButtonSocial
                    onClick={editConfigurableProduct}
                    text={t('cart:cart.configurable.product.edit')}
                    modifiers={['link', 'icon']}
                    glyph='9'
                  />
                ) : null}
              </div>
            </div>
            <div className='dln-cartItem__price'>
              <div>
                <div className='priceBox'>
                  <PriceBox
                    actualPriceValue={mainPriceData?.value}
                    actualPrice={mainPriceData?.formattedValue}
                    oldPriceValue={hasDiscount ? oldPriceData?.value : null}
                    oldPrice={hasDiscount ? oldPriceData?.formattedValue : null}
                    billingTimeDescription={item?.billingTime?.description}
                  />
                  <CartVatRow
                    vat={item.vat}
                    vatRatio={item.vatratio}
                    showVatRatio={false}
                  />
                </div>
              </div>
              {item.productStock &&
                item.productStock.stockLevelStatus === 'lowStock' && (
                  <div className='dln-cartItem__chips'>
                    <Chips
                      modifiers={['lightGray', 'light']}
                      customHTMLContent={t('cart:cart.stock.text', {
                        stock: item.productStock.stockLevel,
                      })}
                    />
                  </div>
                )}
            </div>
            {isSubscription &&
              item.rootGroup.rootBundleTemplate.oneTimePriceData.value <
                item.rootGroup.rootBundleTemplate.recurringPriceData.value &&
              item.rootGroup.rootBundleTemplate?.promoDescription && (
                <div
                  className='dln-cartItem__discount'
                  dangerouslySetInnerHTML={{
                    __html:
                      item.rootGroup.rootBundleTemplate.promoDescription || '',
                  }}
                />
              )}
            <div
              ref={descriptionRef}
              className='dln-cartItem__bundleDescription'
              dangerouslySetInnerHTML={{
                __html:
                  item.rootGroup?.rootBundleTemplate?.htmlDescription || '',
              }}
              style={{ maxHeight: DescriptionHeight }}
            />{' '}
            <button
              type='button'
              className='dln-cartItem__bundleDescription--toggle-accordion'
              onClick={descriptionRefHandler}
            >
              {' '}
              {isDescriptionOpen
                ? t('cart:cart.bundles.close')
                : t('cart:cart.bundles.show')}
            </button>
            <div className='dln-cartItem__quantity'>
              <span className='dln-cartItem__label'>
                {t('cart:cart.popup.qty')}
              </span>
              <div className='dln-inputIncr'>
                <input
                  className='dln-inputIncr__input'
                  type='text'
                  value={1}
                  readOnly
                />
              </div>
              <i
                className='dln-icn dln-icn--iconfont'
                onClick={removeItem}
                role='button'
                tabIndex={0}
              >
                X
              </i>
            </div>
            {item.whatsInTheBoxs && item.whatsInTheBoxs.length > 0 && (
              <div className='dln-cartItem__accessories'>
                <Select
                  values={item.whatsInTheBoxs}
                  id='tools'
                  fieldCode='id'
                  fieldName='title'
                  value=''
                  placeholderLabel={t(
                    'cart:cart.page.accessories.placeholder',
                    {
                      tools: item.whatsInTheBoxs.length,
                    },
                  )}
                  modifiers={['optionsDisabled']}
                />
                {item.accessoriesAvailable && (
                  <ButtonTextIcon
                    onClick={() => addAccessories(item)}
                    text={t('cart:cart.page.accessories.label')}
                  />
                )}
              </div>
            )}
            <p
              className='dln-cartItem__bundleDescription'
              dangerouslySetInnerHTML={{
                __html:
                  item.rootGroup?.rootBundleTemplate?.bundleFeatures
                    .map(feature => feature)
                    .join('<br />') || '',
              }}
            />
          </div>
        </div>
      </div>
      {item.whatsInTheBoxs && item.whatsInTheBoxs.length > 0 && (
        <div className='dln-cartItem__accessoriesMobile'>
          {
            <Select
              values={item.whatsInTheBoxs}
              id='tools'
              fieldCode='id'
              fieldName='title'
              value=''
              placeholderLabel={t('cart:cart.page.accessories.placeholder', {
                tools: item.whatsInTheBoxs.length,
              })}
              modifiers={['optionsDisabled']}
            />
          }
          {item.accessoriesAvailable && (
            <ButtonTextIcon
              onClick={() => addAccessories(item)}
              text={t('cart:cart.page.accessories.label')}
            />
          )}
        </div>
      )}
    </div>
  );
};

SubscriptionCartItem.propTypes = {
  item: PropTypes.shape().isRequired,
  addAccessories: PropTypes.func.isRequired,
};

export default SubscriptionCartItem;
